<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder='Pesquisável pelo campo "searchable"'
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQueryAndHasNumberOfBadges" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label>Account</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-3">
          <label for="consult-status">Status</label>
          <Select2 :options="filterStatus" v-model="query.status"/>
        </div>

        <div class="col-md-3">
          <label>Kind</label>
          <Select2 :options="filterKind" v-model="query.kind"/>
        </div>

        <div class="col-md-3">
          <label>Stage Name</label>
          <Select2 :options="filterStageName" v-model="query.stageName"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-3">
          <label>App Name</label>
          <Select2 :options="filterAppName" v-model="query.appName"/>
        </div>

        <div class="col-md-3">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="consult-day">Data inicial</label>
          <input v-model="query.startDate" type="date" id="consult-day" class="form-control">
        </div>

        <div class="col-md-3">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-3">
          <label>Spider</label>
          <Select2 :options="filterScrapingServiceName" v-model="query.scrapingServiceName"/>
        </div>
      </div>
    </template>

    <hr/>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
            <option value="name">Nome</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>ID</th>
              <th></th>
              <th>Conta</th>
              <th>App</th>
              <th>Status</th>
              <th>Kind</th>
              <th>Fase</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th>Criado por</th>
              <th>Requisitado por</th>
              <th>OrderId</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" :key="order.id">
              <td>
                {{ order.id }}
              </td>
              <td>
                <CopyIcon @click="clipboardUUID(order.uuid)" class="fd-icon ml-1" v-tooltip.right="'Copiar UUID'"/>
              </td>
              <td>{{ getAccountName(order) }}</td>
              <td>{{ order.appName }}</td>
              <td>{{ showStatus(order.status) }}</td>
              <td>{{ order.kind }}</td>
              <td>{{ order.stageName }}</td>
              <td>{{ order.createdAt | datetime }}</td>
              <td>{{ order.updatedAt | datetime }}</td>
              <td>{{ order.createdBy }}</td>
              <td>{{ order.requestedBy }}</td>
              <td v-if="order.orderFlowOrderId">
                <router-link :to="buildLink(order.orderFlowOrderId)">
                  Parent
               </router-link>
              </td>
              <td v-else></td>
              <td>
                <Dropdown title-dropdown="Opções" class="col-md ml-2 btn-sm btn-primary" position="right"> 
                  <ul class="mb-1 mt-1">
                    <li class="dropdown-item">
                      <div @click="show(order)">
                        Ver
                      </div>
                    </li>
                    <li class="dropdown-item">
                      <router-link :to="buildLink(order.id)">
                        Detalhes
                      </router-link>
                    </li>
                    <li v-if="inMaestro(order)" class="dropdown-item">
                      <router-link :to="buildMaestroLink(order)">
                        Detalhes no maestro
                      </router-link>
                    </li>
                  </ul>
                </Dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <ShowDataModal v-model="showModal" header="Order" :data="currentOrder"/>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import Dropdown from '@/components/shares/specialTag/Dropdown.vue'
import ModelMapper from '@/mixins/ModelMapper'
import handleSearchable from '@/models/handleSearchable'
import GetUser from '@/mixins/GetUser'

import Pagination from '@/components/shares/specialTag/Pagination'
import Select2 from '@/components/shares/Select2'
import ShowDataModal from '@/components/admin/ShowDataModal'

import {Filter} from '@/models/filter'
import {ChevronDownIcon, CopyIcon, SearchIcon} from 'vue-feather-icons'

let mapStatus = null

export default {
  components: {BadgeFilters, ChevronDownIcon, Dropdown, CopyIcon, Pagination, SearchIcon, ShowDataModal, Select2},
  computed: {
    orders() {
      return this.getModels || []
    },
    badgeFilters() {
      return [
        this.filterStatus,
        this.filterKind,
        this.filterAppName,
        this.filterStageName,
        this.filterAccount,
        this.filterScrapingServiceName,
        this.filterEndDate,
        this.filterStartDate
      ]
    }
  },
  created() {
    if (this.$utils.isEmpty(this.query.startDate)) {
      const str = this.$utils.toDateInput()
      this.$set(this.query, 'startDate', str)
    }

    mapStatus = {}
    this.$set(this.query, 'periodType', 'created_at')
    this.defaultModelSetting.updateQueryURL = true
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true,
      after: () => this.mountFilters()
    })
    this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
  },
  data: () => ({
    currentOrder: {},
    filterStatus: null,
    filterKind: null,
    filterAppName: null,
    filterStageName: null,
    filterAccount: null,
    filterScrapingServiceName: new Filter({
      key: 'scrapingServiceName',
      label: 'Spider',
      table: [
        ['ANTT', 'autos_antt'],
        ['ANTT Notificação Eletrônica', 'autos_antt_notificacao_eletronica'],
        ['ANTT Processos', 'autos_antt_processos'],
        ['ANTT Processos Multas', 'autos_antt_processos_multas'],
        ['DER PR', 'autos_der_cnd_pr'],
        ['DER SP', 'autos_embarcador_der_sp'],
        ['DNIT', 'autos_dnit'],
      ]
    }),
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    showModal: false,
    modelPathPrefix: 'admin',
    nameModel: 'Order',
    orderBy: 'created_at',
  }),
  inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
  methods: {
    buildLink(orderId) {
      return `${this.currentPath}/${orderId}`
    },
    buildMaestroLink(order) {
      return `/admin/maestro/orders?q[generic]=${order.uuid}&q[startDate]=${order.createdAt}`
    },
    buildParams(pagination) {
      if (this.query.generic)
        this.query.generic = handleSearchable(this.query.generic)

      return ModelMapper.methods.buildParams.call(this, pagination)
    },
    find() {
      this.asyncTemplateSelect()
    },
    inMaestro(order) {
      if (!this.platformModule)
        return false

      return ['cm-frotas', 'cm-taxas', 'cm-crono', 'cm-embarcador'].includes(order.appName)
    },
    buildPath() {
      return this.currentPath
    },
    showStatus(status) {
      if (Object.keys(mapStatus).length > 0)
        return mapStatus[status]

      if (!this.filterStatus)
        return status

      this.filterStatus.forEach(obj => mapStatus[obj.value] = obj.label)
      return mapStatus[status]
    },
    mountFilters() {
      const key = `${this.currentPath}/fetch_columns`
      const mount = (data) => {
        this.filterStatus = new Filter({key: 'status', label: 'Status', table: data['status']})
        this.filterKind = new Filter({key: 'kind', label: 'Kind', table: data['kind']})
        this.filterAppName = new Filter({key: 'appName', label: 'AppName', table: data['app_name']})
        this.filterStageName = new Filter({key: 'stageName', label: 'StageName', table: data['stage_name']})
      }

      const data = this.$ls.get(key)
      if (data)
        return mount(data)

      this.axios.get(key)
        .then(response => {
          mount(response.data)
          this.$ls.set(key, data, {minutes: 5})
        })
    },
    clipboardUUID(uuid) {
      const input = document.createElement('input');
      input.value = uuid
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    },
    show(item) {
      this.showModal = true
      this.currentOrder = item
    },
  },
  mixins: [ModelMapper, GetUser],
  name: 'AdminOrdersIndex',
  watch: {
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  },
  props: {
    currentPath: {
      required: true,
      type: String
    },
    platformModule: {
      type: Boolean,
      default: false
    }
  }
}
</script>
